// extracted by mini-css-extract-plugin
module.exports = {"passenger":"passenger-3K74u"};